import * as models from './models'

export interface State {
  assignments: State.Entry<models.UnitOutcomeAssignment>
  assignmentsFilters: readonly models.UnitOutcomeAssignment.Filter[]
  outcomes: State.Entry<models.Outcome>
  units: State.Entry<models.Unit>
}
export namespace State {
  export const INITIAL: State = {
    assignments: { data: [] },
    assignmentsFilters: models.UnitOutcomeAssignment.Filter.DEFAULTS,
    outcomes: { data: [] },
    units: { data: [] },
  }

  export type Entry<T> = ExactlyOneOf<{
    data: readonly T[]
    loading: boolean
    error: Error
  }>
}
